// Laadt Calendly CSS + JS asynchroon (zonder CORS) en initialiseert de secties
(function () {
  function ensureCalendlyLoaded(cb) {
    if (window.Calendly) { cb && cb(); return; }

    // CSS (geen crossorigin!)
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = 'https://assets.calendly.com/assets/external/widget.css';
    document.head.appendChild(l);

    // JS (geen crossorigin!)
    var s = document.createElement('script');
    s.src = 'https://assets.calendly.com/assets/external/widget.js';
    s.async = true;
    s.defer = true;
    s.onload = function () { cb && cb(); };
    document.head.appendChild(s);
  }

  function initCalendlySection(sectionEl) {
    if (!sectionEl) return;
    var url = sectionEl.getAttribute('data-url');
    var height = parseInt(sectionEl.getAttribute('data-height'), 10) || 700;
    var parent = sectionEl.querySelector('.calendly-container');
    if (!url || !parent) return;

    parent.innerHTML = '';
    parent.style.minWidth = '320px';
    parent.style.height = height + 'px';

    ensureCalendlyLoaded(function () {
      parent.innerHTML = '';
      window.Calendly.initInlineWidget({ url: url, parentElement: parent });
    });
  }

  // Init bij DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-calendly-section]').forEach(initCalendlySection);
  });

  // Theme Editor events
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector('[data-calendly-section]');
    if (el) initCalendlySection(el);
  });
  document.addEventListener('shopify:section:select', function (e) {
    var el = e.target && e.target.querySelector('[data-calendly-section]');
    if (el) initCalendlySection(el);
  });
})();
